import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  handle(error: HttpErrorResponse): string {
    if (error.status === 0) {
      return 'Unable to connect to server.';
    }

    switch (error.status) {
      case 400:
        return 'Bad Request';

      case 401:
        return 'Unauthorized Access';

      case 403:
        return 'Access Denied';

      case 404:
        return 'Requested Resource Not Found';

      case 500:
        return 'Internal Server Error';

      case 502:
        return 'Bad Gateway';

      case 503:
        return 'Service Unavailable';

      default:
        return 'Something went wrong.';
    }
  }
}
